/**
 * Create Product Groups context for custom hook
 */
import { createContext } from 'react'

const LoyaltyPointTransactionsContext = createContext({
  fetchLoyaltyPointTransactions: () => {},
})

export default LoyaltyPointTransactionsContext
